import { AnalyticsProvider } from './base';
import type { UserProperties, PageViewData, PentictonEventsTracking } from '../types';

/**
 * No-operation analytics provider for development or when analytics is disabled
 */
export class NoopProvider extends AnalyticsProvider {
  async initialize(): Promise<void> {
    this.log('Noop provider initialized - no tracking will occur');
  }

  trackEvent<T extends keyof PentictonEventsTracking>(
    eventName: T,
    properties: PentictonEventsTracking[T],
  ): void {
    this.log('Event would be tracked', { eventName, properties });
  }

  trackPageView(data: PageViewData): void {
    this.log('Page view would be tracked', data);
  }

  setUserProperties(properties: UserProperties): void {
    this.log('User properties would be set', properties);
  }

  setConsent(granted: boolean): void {
    this.consentGranted = granted;
    this.log('Consent updated', { granted });
  }
}
